import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    Collapse,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@material-ui/core';
import { ProfitLossReportCss as useStyles } from './ReportSideBarCss';
import RightSideBar from '../RightSideBar/RightSideBar';
import * as logger from '../../../logger';
import { numberFormat } from '../../../utils/utils';
import { getProfitLossReport, profitLossPdfV2 } from '../../../store/actions/userActionCreators';
import { getAllPnlMonths } from '../../../store/actions/homeActionCreator';
import FilterComponent from '../FilterComponent/FilterComponent';
import ReportsDialog from '../ReportsDialog/ReportsDialog';
import AddIcon from '@material-ui/icons/Add';
import { ProfitLossReportIconHome } from '../../../components/icons';
import { trackDwebEvent } from '../../analytics';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const ProfitLossReport = ({ open, onClose, user, trip, dispatchGetProfitLossReport, dispatchGetPnlMonths, handleAddTrip }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [dateFilterValue, setDateFilterValue] = useState("");
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [profitLossReport, setProfitLossReport] = useState({});
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
    const [showPdfButton, setShowPdfButton] = useState(false);
    const [partyChargesOpen,setPartyChargesOpen] = useState(false);
    const [partyChargesHiredOpen,setPartyChargesHiredOpen] = useState(false);
    const [partyDeductionsOpen,setPartyDeductionsOpen] = useState(false);
    const [partyDeductionsHiredOpen,setPartyDeductionsHiredOpen] = useState(false);
    const [supplierChargesHiredOpen,setSupplierChargesHiredOpen] = useState(false);
    const [supplierDeductionsHiredOpen,setSupplierDeductionsHiredOpen] = useState(false);




    const classes = useStyles();

    useEffect(() => {

        dispatchGetPnlMonths(
            (data) => {
                // if (data && data.status && data.status.code == 200) {
                logger.log("Truck Income Report Dweb", 'Get PNL months successfull');

                const filterValue = {
                    monthYear: data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : ""
                };

                trackDwebEvent("Dweb Profit and Loss Report", {
                    default_month: data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : ""
                });

                setDateFilterValue(data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : "");
                dispatchGetProfitLossReport(filterValue,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Profit Loss Report Dweb', 'Get Profit Loss Report Successfull');
                        }
                    },
                    () => {
                        logger.log('Profit Loss Report Dweb', 'Get Profit Loss Report Failed');
                    }
                );
            },
            () => {

            }
        );

    }, []);

    useEffect(() => {

        if (changeDataFlag) {
            const filterValue = {
                monthYear: dateFilterValue ? dateFilterValue : ""
            };

            dispatchGetProfitLossReport(filterValue,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Profit Loss Report Dweb", "Get Profit Loss Report Successfull");
                    }
                },
                () => {
                    logger.log("Profit Loss Report Dweb", "Get Profit Loss Report Failed");
                }
            );
        }

    }, [dateFilterValue]);

    useEffect(() => {
        if (user && user.profitLossReport) {
            setProfitLossReport(user.profitLossReport);

            if (user.profitLossReport.noOfTrips && user.profitLossReport.noOfTrips == 0) {
                setShowPdfButton(false);
            } else if (user.profitLossReport.noOfTrips && user.profitLossReport.noOfTrips > 0) {
                setShowPdfButton(true);
            }
        }
    }, [user.profitLossReport]);

    const handleViewPdf = () => {
        setPdfDialogOpen(true);
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        setProfitLossReport({});
        user.profitLossReport = {}
    }

    const handlePnlDate = (dateValue) => {
        setDateFilterValue(dateValue);
        setChangeDataFlag(true);
    }

    const handleClosePdf = () => {
        setPdfDialogOpen(false);
    }
    const handlePartyCharges = () =>{
        setPartyChargesOpen(!partyChargesOpen)
    }
    const handlePartyChargesHired = () =>{
        setPartyChargesHiredOpen(!partyChargesHiredOpen)
    }
    const handlePartyDeductions = () =>{
        setPartyDeductionsOpen(!partyDeductionsOpen)
    }
    const handlePartyDeductionsHired = () =>{
        setPartyDeductionsHiredOpen(!partyDeductionsHiredOpen)
    }
    const handleSupplierChargesHired = () =>{
        setSupplierChargesHiredOpen(!supplierChargesHiredOpen)
    }
    const handleSupplierDeductionsHired = () =>{
        setSupplierDeductionsHiredOpen(!supplierDeductionsHiredOpen)
    }
    return (
        <>
            {open && <RightSideBar
                rightSideBarOpen={dialogOpen}
                sideBarTitle={'Profit and Loss Report'}
                sideBarType="reports"
                handleSubmit={event => handleViewPdf(event)}
                toggleRightSideBar={handleClose}
                fromProfitLossReport={true}
                showViewPdf={showPdfButton}
                titleType="reports"
            >
                <div className={classes.divFilter}>
                    <FilterComponent reportType={"Profit Loss Report"} pnlDate={handlePnlDate} />
                </div>
                {profitLossReport && profitLossReport.noOfTrips == 0 && profitLossReport && profitLossReport.cost && profitLossReport.cost.officeCost && !profitLossReport.cost.officeCost.costItems &&
                    <div className={classes.divEmptyState}>
                        <div>
                            <ProfitLossReportIconHome className={classes.profitLossIcon} />
                        </div>
                        <div className={classes.divEmptyText}>
                            Add a Trip to get Profit Report
                        </div>
                        <div>
                            <Button variant="contained" className={classes.addTripButton} onClick={handleAddTrip} >
                                <AddIcon />
                                <span>
                                    Add Trip
                                </span>
                            </Button>
                        </div>
                    </div>
                }
                {(profitLossReport && profitLossReport.noOfTrips > 0 || profitLossReport && profitLossReport.cost && profitLossReport.cost.officeCost && profitLossReport.cost.officeCost.costItems) &&
                    <div>
                        <div className={profitLossReport && profitLossReport.profit && profitLossReport.profit.overall > 0 ? classes.divAlignProfit : classes.divAlignLoss}>
                            <div>
                                Overall Profit for&nbsp;{profitLossReport && profitLossReport.monthNameFull ? profitLossReport.monthNameFull : ""}
                            </div>
                            <div>
                                {profitLossReport && profitLossReport.profit && profitLossReport.profit.overall ? numberFormat(profitLossReport.profit.overall) : numberFormat(0)}
                            </div>
                        </div>

                        <div className={classes.divReportData}>
                            <Grid
                                container
                                className={classes.gridContainer}
                            >
                                <Grid container>

                                    <Grid container justify="space-between" className={classes.gridContainerV1}>
                                        <Grid item>
                                            Number of Trips Started in&nbsp;{profitLossReport && profitLossReport.monthNameFull ? profitLossReport.monthNameFull : ""}
                                        </Grid>
                                        <Grid item>
                                            {profitLossReport.noOfTrips}
                                        </Grid>
                                    </Grid>
                                    <Grid container justify="space-between" className={classes.gridContainerV2}>
                                        <Grid item>
                                            Overall Revenue in&nbsp;{profitLossReport && profitLossReport.monthNameFull ? profitLossReport.monthNameFull : ""}
                                        </Grid>
                                        <Grid item>
                                            {profitLossReport && profitLossReport.revenue && profitLossReport.revenue.overall ? numberFormat(profitLossReport.revenue.overall) : numberFormat(0)}
                                        </Grid>
                                    </Grid>

                                    <Grid container direction="column">
                                        <Grid container justify="space-between" className={classes.gridContainerV3}>
                                            <Grid item>
                                                Revenue from Own Trucks
                                            </Grid>
                                            <Grid item>
                                                {profitLossReport && profitLossReport.revenue && profitLossReport.revenue.own && profitLossReport.revenue.own.overall ? numberFormat(profitLossReport.revenue.own.overall) : numberFormat(0)}
                                            </Grid>
                                        </Grid>

                                        <Grid container direction="column" className={classes.gridContainerV4}>
                                            {profitLossReport && profitLossReport.revenue && profitLossReport.revenue.own && profitLossReport.revenue.own.revenueItems.map((itemData) => itemData.display && !itemData.display.includes("Total")?(
                                                itemData.display && !itemData.display.includes("Total") && <Grid container justify="space-between" className={classes.gridContainerV5}>
                                                    <Grid item>
                                                        {itemData.display}
                                                    </Grid>
                                                    <Grid item>
                                                        {numberFormat(itemData.amount)}
                                                    </Grid>
                                                </Grid>
                                            ):null)}
                                            {profitLossReport && profitLossReport.partyCharges && profitLossReport.partyCharges.own && profitLossReport.partyCharges.own.overall==0?<Grid container justify="space-between" className={classes.gridContainerV5}>
                                                <Grid item>
                                                    Party Charges
                                                </Grid>
                                                <Grid item>
                                                    {numberFormat(0)}
                                                </Grid>
                                            </Grid>:null}
                                            {profitLossReport && profitLossReport.partyDeductions && profitLossReport.partyDeductions.own && profitLossReport.partyDeductions.own.overall==0?<Grid container justify="space-between" className={classes.gridContainerV5}>
                                                <Grid item>
                                                    Party Deductions
                                                </Grid>
                                                <Grid item>
                                                    {numberFormat(0)}
                                                </Grid>
                                            </Grid>:null}
                                        </Grid>
                                        {profitLossReport && profitLossReport.partyCharges && profitLossReport.partyCharges.own && profitLossReport.partyCharges.own.overall && profitLossReport.partyCharges.own.overall>0 ?<Grid container direction="column" className={classes.gridContainerList}>
                                            <List
                                                component="ul"
                                                aria-labelledby="party-charges-list"
                                                className={classes.root}
                                                >
                                                <ListItem onClick={handlePartyCharges} className={classes.listHead}>
                                                    {!partyChargesOpen ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                                                    <ListItemText className={classes.listPrimary} primary="Party Charges" />
                                                    <Typography className={classes.listPrimaryAmount}>{numberFormat(profitLossReport.partyCharges.own.overall)}</Typography>
                                                </ListItem>
                                                {profitLossReport && profitLossReport.partyCharges && profitLossReport.partyCharges.own && profitLossReport.partyCharges.own.chargeItems && <Collapse in={partyChargesOpen} timeout="auto" unmountOnExit>
                                                    <List className={classes.nestedRoot} component="div" disablePadding>
                                                        {
                                                             profitLossReport.partyCharges.own.chargeItems.map((itemData) => (
                                                                <ListItem className={classes.nested}>
                                                                    <ListItemText className={classes.listSec} primary={itemData.display} />
                                                                    <Typography className={classes.listSecAmount}>{numberFormat(itemData.amount)}</Typography>
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>
                                                </Collapse>}
                                            </List>
                                        </Grid>:null}
                                        {profitLossReport && profitLossReport.partyDeductions && profitLossReport.partyDeductions.own && profitLossReport.partyDeductions.own.overall && profitLossReport.partyDeductions.own.overall>0 ?<Grid container direction="column" className={classes.gridContainerList}>
                                            <List
                                                component="ul"
                                                aria-labelledby="party-deduction-list"
                                                className={classes.root}
                                                >
                                                <ListItem onClick={handlePartyDeductions} className={classes.listHead}>
                                                    {!partyDeductionsOpen ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                                                    <ListItemText className={classes.listPrimary} primary="Party Deductions" />
                                                    <Typography className={classes.listPrimaryAmount}>-{numberFormat(profitLossReport.partyDeductions.own.overall)}</Typography>
                                                </ListItem>
                                                {profitLossReport && profitLossReport.partyDeductions && profitLossReport.partyDeductions.own && profitLossReport.partyDeductions.own.deductionItems && <Collapse in={partyDeductionsOpen} timeout="auto" unmountOnExit>
                                                    <List className={classes.nestedRoot} component="div" disablePadding>
                                                        {
                                                             profitLossReport.partyDeductions.own.deductionItems.map((itemData) => (
                                                                <ListItem className={classes.nested}>
                                                                    <ListItemText className={classes.listSec} primary={itemData.display} />
                                                                    <Typography className={classes.listSecAmount}>-{numberFormat(itemData.amount)}</Typography>
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>
                                                </Collapse>}
                                            </List>
                                        </Grid>:null}
                                    </Grid>

                                    <Grid container direction="column">
                                        <Grid container justify="space-between" className={classes.gridContainerV6}>
                                            <Grid item>
                                                Revenue from Market Trucks
                                            </Grid>
                                            <Grid item>
                                                {profitLossReport && profitLossReport.revenue && profitLossReport.revenue.hired && profitLossReport.revenue.hired.overall ? numberFormat(profitLossReport.revenue.hired.overall) : numberFormat(0)}
                                            </Grid>
                                        </Grid>

                                        <Grid container direction="column" className={classes.gridContainerV7}>
                                            {profitLossReport && profitLossReport.revenue && profitLossReport.revenue.hired && profitLossReport.revenue.hired.revenueItems.map((itemData) => itemData.display && !itemData.display.includes("Total")?(
                                                <Grid container justify="space-between" className={classes.gridContainerV8}>
                                                    <Grid item>
                                                        {itemData.display}
                                                    </Grid>
                                                    <Grid item>
                                                        {numberFormat(itemData.amount)}
                                                    </Grid>
                                                </Grid>
                                            ):null)}
                                            {profitLossReport && profitLossReport.partyCharges && profitLossReport.partyCharges.hired && profitLossReport.partyCharges.hired.overall==0?<Grid container justify="space-between" className={classes.gridContainerV5}>
                                                <Grid item>
                                                    Party Charges
                                                </Grid>
                                                <Grid item>
                                                    {numberFormat(0)}
                                                </Grid>
                                            </Grid>:null}
                                            {profitLossReport && profitLossReport.partyDeductions && profitLossReport.partyDeductions.hired && profitLossReport.partyDeductions.hired.overall==0?<Grid container justify="space-between" className={classes.gridContainerV5}>
                                                <Grid item>
                                                    Party Deductions
                                                </Grid>
                                                <Grid item>
                                                    {numberFormat(0)}
                                                </Grid>
                                            </Grid>:null}
                                        </Grid>
                                        {profitLossReport && profitLossReport.partyCharges && profitLossReport.partyCharges.hired && profitLossReport.partyCharges.hired.overall && profitLossReport.partyCharges.hired.overall>0?<Grid container direction="column" className={classes.gridContainerList}>
                                            <List
                                                component="ul"
                                                aria-labelledby="party-charges-list-hirded"
                                                className={classes.root}
                                                >
                                                <ListItem onClick={handlePartyChargesHired} className={classes.listHead}>
                                                    {!partyChargesHiredOpen ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                                                    <ListItemText className={classes.listPrimary} primary="Party Charges" />
                                                    <Typography className={classes.listPrimaryAmount}>{numberFormat(profitLossReport.partyCharges.hired.overall)}</Typography>
                                                </ListItem>
                                                {profitLossReport && profitLossReport.partyCharges && profitLossReport.partyCharges.hired && profitLossReport.partyCharges.hired.chargeItems && <Collapse in={partyChargesHiredOpen} timeout="auto" unmountOnExit>
                                                    <List className={classes.nestedRoot} component="div" disablePadding>
                                                        {
                                                             profitLossReport.partyCharges.hired.chargeItems.map((itemData) => (
                                                                <ListItem className={classes.nested}>
                                                                    <ListItemText className={classes.listSec} primary={itemData.display} />
                                                                    <Typography className={classes.listSecAmount}>{numberFormat(itemData.amount)}</Typography>
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>
                                                </Collapse>}
                                            </List>
                                        </Grid>:null}
                                        {profitLossReport && profitLossReport.partyDeductions && profitLossReport.partyDeductions.hired && profitLossReport.partyDeductions.hired.overall && profitLossReport.partyDeductions.hired.overall>0?<Grid container direction="column" className={classes.gridContainerList}>
                                            <List
                                                component="ul"
                                                aria-labelledby="party-ded-list-hirded"
                                                className={classes.root}
                                                >
                                                <ListItem onClick={handlePartyDeductionsHired} className={classes.listHead}>
                                                    {!partyDeductionsHiredOpen ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                                                    <ListItemText className={classes.listPrimary} primary="Party Deductions" />
                                                    <Typography className={classes.listPrimaryAmount}>-{numberFormat(profitLossReport.partyDeductions.hired.overall)}</Typography>
                                                </ListItem>
                                                {profitLossReport && profitLossReport.partyDeductions && profitLossReport.partyDeductions.hired && profitLossReport.partyDeductions.hired.deductionItems && <Collapse in={partyDeductionsHiredOpen} timeout="auto" unmountOnExit>
                                                    <List className={classes.nestedRoot} component="div" disablePadding>
                                                        {
                                                             profitLossReport.partyDeductions.hired.deductionItems.map((itemData) => (
                                                                <ListItem className={classes.nested}>
                                                                    <ListItemText className={classes.listSec} primary={itemData.display} />
                                                                    <Typography className={classes.listSecAmount}>-{numberFormat(itemData.amount)}</Typography>
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>
                                                </Collapse>}
                                            </List>
                                        </Grid>:null}
                                    </Grid>

                                    <Grid container justify="space-between" className={classes.gridContainerV2}>
                                        <Grid item>
                                            Overall cost in&nbsp;{profitLossReport && profitLossReport.monthNameFull ? profitLossReport.monthNameFull : ""}
                                        </Grid>
                                        <Grid item>
                                            {profitLossReport && profitLossReport.cost && profitLossReport.cost.overall ? numberFormat(profitLossReport.cost.overall) : numberFormat(0)}
                                        </Grid>
                                    </Grid>

                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.own && profitLossReport.cost.own.costItems && profitLossReport.cost.own.costItems.length > 0 &&
                                        <Grid container direction="column">
                                            <Grid container justify="space-between" className={classes.gridContainerV6}>
                                                <Grid item>
                                                    Cost for Trips with Own Trucks
                                                </Grid>
                                                <Grid item>
                                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.own && profitLossReport.cost.own.overall ? numberFormat(profitLossReport.cost.own.overall) : numberFormat(0)}
                                                </Grid>
                                            </Grid>

                                            <Grid container direction="column" className={classes.gridContainerV7}>
                                                {profitLossReport && profitLossReport.cost && profitLossReport.cost.own && profitLossReport.cost.own.costItems.map((itemData) => (
                                                    <Grid container justify="space-between" className={classes.gridContainerV8}>
                                                        <Grid item>
                                                            {itemData.display}
                                                        </Grid>
                                                        <Grid item>
                                                            {numberFormat(itemData.amount)}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    }

                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.hired && profitLossReport.cost.hired.costItems && profitLossReport.cost.hired.costItems.length > 0 &&
                                        <Grid container direction="column">
                                            <Grid container justify="space-between" className={classes.gridContainerV6}>
                                                <Grid item>
                                                    Cost for Trips with Market Trucks
                                                </Grid>
                                                <Grid item>
                                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.hired && profitLossReport.cost.hired.overall ? numberFormat(profitLossReport.cost.hired.overall) : numberFormat(0)}
                                                </Grid>
                                            </Grid>

                                            <Grid container direction="column" className={classes.gridContainerV7}>
                                                {profitLossReport && profitLossReport.cost && profitLossReport.cost.hired && profitLossReport.cost.hired.costItems.map((itemData) => (
                                                    <Grid container justify="space-between" className={classes.gridContainerV8}>
                                                        <Grid item>
                                                            {itemData.display}
                                                        </Grid>
                                                        <Grid item>
                                                            {numberFormat(itemData.amount)}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                            {profitLossReport && profitLossReport.supplierCharges && profitLossReport.supplierCharges.hired && profitLossReport.supplierCharges.hired.overall && profitLossReport.supplierCharges.hired.overall>0?<Grid container direction="column" className={classes.gridContainerList}>
                                                <List
                                                    component="ul"
                                                    aria-labelledby="supplierCharges-list-hired"
                                                    className={classes.root}
                                                    >
                                                    <ListItem onClick={handleSupplierChargesHired} className={classes.listHead}>
                                                        {!supplierChargesHiredOpen ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                                                        <ListItemText className={classes.listPrimary} primary="Supplier Charges" />
                                                        <Typography className={classes.listPrimaryAmount}>{numberFormat(profitLossReport.supplierCharges.hired.overall)}</Typography>
                                                    </ListItem>
                                                    {profitLossReport && profitLossReport.supplierCharges && profitLossReport.supplierCharges.hired && profitLossReport.supplierCharges.hired.chargeItems && <Collapse in={supplierChargesHiredOpen} timeout="auto" unmountOnExit>
                                                        <List className={classes.nestedRoot} component="div" disablePadding>
                                                            {
                                                                profitLossReport.supplierCharges.hired.chargeItems.map((itemData) => (
                                                                    <ListItem className={classes.nested}>
                                                                        <ListItemText className={classes.listSec} primary={itemData.display} />
                                                                        <Typography className={classes.listSecAmount}>{numberFormat(itemData.amount)}</Typography>
                                                                    </ListItem>
                                                                ))
                                                            }
                                                        </List>
                                                    </Collapse>}
                                                </List>
                                            </Grid>:null}
                                            {profitLossReport && profitLossReport.supplierDeductions && profitLossReport.supplierDeductions.hired && profitLossReport.supplierDeductions.hired.overall && profitLossReport.supplierDeductions.hired.overall>0?<Grid container direction="column" className={classes.gridContainerList}>
                                                <List
                                                    component="ul"
                                                    aria-labelledby="supplier-ded-list-hirded"
                                                    className={classes.root}
                                                    >
                                                    <ListItem onClick={handleSupplierDeductionsHired} className={classes.listHead}>
                                                        {!supplierDeductionsHiredOpen ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                                                        <ListItemText className={classes.listPrimary} primary="Supplier Deductions" />
                                                        <Typography className={classes.listPrimaryAmount}>-{numberFormat(profitLossReport.supplierDeductions.hired.overall)}</Typography>
                                                    </ListItem>
                                                    {profitLossReport && profitLossReport.supplierDeductions && profitLossReport.supplierDeductions.hired && profitLossReport.supplierDeductions.hired.deductionItems && <Collapse in={supplierDeductionsHiredOpen} timeout="auto" unmountOnExit>
                                                        <List className={classes.nestedRoot} component="div" disablePadding>
                                                            {
                                                                profitLossReport.supplierDeductions.hired.deductionItems.map((itemData) => (
                                                                    <ListItem className={classes.nested}>
                                                                        <ListItemText className={classes.listSec} primary={itemData.display} />
                                                                        <Typography className={classes.listSecAmount}>-{numberFormat(itemData.amount)}</Typography>
                                                                    </ListItem>
                                                                ))
                                                            }
                                                        </List>
                                                    </Collapse>}
                                                </List>
                                            </Grid>:null}
                                        </Grid>
                                    }

                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.vehicleCost && profitLossReport.cost.vehicleCost.costItems && profitLossReport.cost.vehicleCost.costItems.length > 0 &&
                                        <Grid container direction="column">
                                            <Grid container justify="space-between" className={classes.gridContainerV6}>
                                                <Grid item>
                                                    Truck Cost
                                                </Grid>
                                                <Grid item>
                                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.vehicleCost && profitLossReport.cost.vehicleCost.overall ? numberFormat(profitLossReport.cost.vehicleCost.overall) : numberFormat(0)}
                                                </Grid>
                                            </Grid>

                                            <Grid container direction="column" className={classes.gridContainerV7}>
                                                {profitLossReport && profitLossReport.cost && profitLossReport.cost.vehicleCost && profitLossReport.cost.vehicleCost.costItems.map((itemData) => (
                                                    <Grid container justify="space-between" className={classes.gridContainerV8}>
                                                        <Grid item>
                                                            {itemData.display}
                                                        </Grid>
                                                        <Grid item>
                                                            {numberFormat(itemData.amount)}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    }

                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.officeCost && profitLossReport.cost.officeCost.costItems && profitLossReport.cost.officeCost.costItems.length > 0 &&
                                        <Grid container direction="column">
                                            <Grid container justify="space-between" className={classes.gridContainerV6}>
                                                <Grid item>
                                                    Office Cost
                                                </Grid>
                                                <Grid item>
                                                    {profitLossReport && profitLossReport.cost && profitLossReport.cost.officeCost && profitLossReport.cost.officeCost.overall ? numberFormat(profitLossReport.cost.officeCost.overall) : numberFormat(0)}
                                                </Grid>
                                            </Grid>

                                            <Grid container direction="column" className={classes.gridContainerV7}>
                                                {profitLossReport && profitLossReport.cost && profitLossReport.cost.officeCost && profitLossReport.cost.officeCost.costItems.map((itemData) => (
                                                    <Grid container justify="space-between" className={classes.gridContainerV8}>
                                                        <Grid item>
                                                            {itemData.display}
                                                        </Grid>
                                                        <Grid item>
                                                            {numberFormat(itemData.amount)}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    }

                                    <Grid container justify="space-between" className={profitLossReport && profitLossReport.profit && profitLossReport.profit.overall > 0 ? classes.gridContainerV10 : classes.gridContainerV13} >
                                        <Grid item>
                                            Overall Profit for&nbsp;{profitLossReport && profitLossReport.monthNameFull ? profitLossReport.monthNameFull : ""}
                                        </Grid>
                                        <Grid item>
                                            {profitLossReport && profitLossReport.profit && profitLossReport.profit.overall ? numberFormat(profitLossReport.profit.overall) : numberFormat(0)}
                                        </Grid>
                                    </Grid>

                                    <Grid container justify="space-between" className={classes.gridContainerV11} >
                                        <Grid item>
                                            Profit From Own Trucks
                                        </Grid>
                                        <Grid item className={profitLossReport && profitLossReport.profit && profitLossReport.profit.own < 0 ? classes.amountLoss : ""} >
                                            {profitLossReport && profitLossReport.profit && profitLossReport.profit.own ? numberFormat(profitLossReport.profit.own) : numberFormat(0)}
                                        </Grid>
                                    </Grid>

                                    <Grid container justify="space-between" className={classes.gridContainerV12} >
                                        <Grid item>
                                            Profit From Market Trucks
                                        </Grid>
                                        <Grid item className={profitLossReport && profitLossReport.profit && profitLossReport.profit.hired < 0 ? classes.amountLoss : ""}>
                                            {profitLossReport && profitLossReport.profit && profitLossReport.profit.hired ? numberFormat(profitLossReport.profit.hired) : numberFormat(0)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
            </RightSideBar>}
            {
                pdfDialogOpen &&
                <ReportsDialog open={pdfDialogOpen} name={"Profit and Loss Report"} pdfMonth={dateFilterValue} onClose={handleClosePdf} reportType={"excelReports"} />
            }
        </>
    );
}

export const mapStateToProps = (state) => (state);
export const mapDispatchToProps = (dispatch) => ({
    dispatchGetProfitLossReport: (filterData, onSuccess, onError) => {
        dispatch(getProfitLossReport(filterData, onSuccess, onError))
    },
    dispatchGetPnlMonths: (onSuccess, onError) => {
        dispatch(getAllPnlMonths(null, onSuccess, onError))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfitLossReport);